import { API_PROXY_GET_FILE } from 'src/constants';
import { sendCloudWatchAlert } from './applicationError';
import axios from 'axios';

const createImage = async (url, useProxyIfFailed = true) => {
  const image = new Image();
  try {
    image.crossOrigin = 'anonymous';
    image.src = url;
    await image.decode();
  } catch (err) {
    sendCloudWatchAlert(`Image can't be decoded ${url} ${err}`);
    if (useProxyIfFailed) {
      return createImage(`${axios.defaults.baseURL}${API_PROXY_GET_FILE}?fileUrl=${url}`, false)
    }
  }
  return image;
};

export const getCroppedImg = async (imageSrc, pixelCrop) => {
  const image = await createImage(imageSrc);
  let croppedImage = '';
  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = 'transparent';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  croppedImage = canvas.toDataURL('image/png');
  return croppedImage;
};
